import type { enClarity } from './en-clarity';

/** Turkish strings — combat-readability settings (docs/12 E1-E5). */
export const trClarity: Record<keyof typeof enClarity, string> = {
  'settings.dmgNumbers': 'Hasar Sayıları',
  'settings.dmgNumbers.off': 'KAPALI',
  'settings.dmgNumbers.crits': 'SADECE CRIT',
  'settings.dmgNumbers.all': 'HEPSİ (birleşik)',
  'settings.shake': 'Ekran Sarsıntısı',
  'settings.shake.off': 'KAPALI',
  'settings.shake.low': 'DÜŞÜK',
  'settings.shake.full': 'TAM',
  'settings.effects': 'Efekt Yoğunluğu',
  'settings.effects.low': 'DÜŞÜK',
  'settings.effects.medium': 'ORTA',
  'settings.effects.high': 'YÜKSEK',
};
